///<reference path="../short-cuts/index.d.ts"/>

module Meevo.Components.Controls {
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    import CoSearchResultsFilter = Meevo.Model.CoSearchResultsFilter;
    import CoSearchType = Meevo.Model.CoSearchType;
    'use strict';

    export class MaintenanceFormSearch {
        private itemsPerPage: number = 25;
        private securityParts = Meevo.Components.Common.SecurityParts;
        private userHasSingleBusinessType: Meevo.Model.DataDetail;
        private securityKeys = Meevo.Components.Common.SecurityKeys;
        restrict = "E";
        templateUrl = 'app/components/controls/maintenanceFormSearchTemplate.html';

        scope = {
            baseEndpoint: "@",
            filterTemplateUrl: "@",
            showActiveCount: "=?",
            itemTemplateUrl: "@",
            visualState: "=",
            searchContext: "=",
            searchContextCriteria: "=",
            searchFallbackCriteria: "=",
            selectedItemId: "=",
            initialEditSection: "=",
            asLocationId: "=?",
            disableCrud: "=",
            view: "=",
            items: "=?",
            advancedSearchTemplate: "@",
            advancedSearchMobileTemplate: "@?",
            chipTemplate: "@",
            templateController: "@",
            headerContentKey: "@",
            coSearchTemplate: "@?",
            coMobileSearchFilterTemplate: "@?",
            notificationBeforeAddState: "&?",
            closeWhenStatesUntruthy: "=", // Allows advanced search to close when base criteria filters are untruthy
            noun: "@?", // Noun for Usage Tracking
            displayNameColumnsCustom: "=?",   // custom set of columns
            coColumnsCustom: "=?",   // custom set of columns,
            hideExistsAtColumn: "=?",
            allowAllBusinesstype: "=",
            baseMainKey: "=?",
            customClass: "=?",
            customStyle: "=?",
            showResults: "=?",
            showTableHeaderRegardlessOfCommonRules: "=?", // currently table header is shown only in CO mode. The setting allows to show it anyway
            controllerObject: "=?",  // link to the angular controller object. for retrieving additional data.
            postItemRetrievalFunction: "=?",
            coFilterBoolean: "=?", // links to the hideCoFilters which controls wether or not filter headers are shown
            isSearchGlobal: "=?", //used to pass isGlobal search criteria between maintenanceFormSearch and maintenanceForm
            preSearchCallback: "&?",
            canLocationAdd: "=?",
            //preserveAdvanceFilter: "=?"
            supportsInactive: "=?",
            clearSearchContextCriteria: "&?",
            bgClass: "@?",
            isDarkBg: "<?",
            exportList: "&?",
            showBottomCrudBar: "=?",
            disableSorting: "=?"
        };

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
            scope.criteria = {
                includeActive: true,
                view: scope.view,
                coSearchType: null,
                coBusinessTypeId: null,
                coFilterByLocationId: null,
                coSearchResultFilter: CoSearchResultsFilter.All,
                location: null,
                businessType: null,
                maintenanceMode: true
            };

            /**
            * Determines whether the application is in CO mode
            */
            scope.isApplicationModeCO = (): boolean => {
                return this.identityService.inCentralOfficeMode();
            }

            scope.isSingleLocation = (): boolean => {
                if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                    return this.identityService.current().isSingleLocation;
                else
                    return false;
            }
            if (_.isUndefined(scope.bgClass)) { scope.bgClass = 'bg-faint-purple'; }
            scope.isDarkBg = _.isUndefined(scope.isDarkBg) ? false : true;


            let servicesWizardModal: Meevo.Components.Modal.IModalOptions = {
                clickOutsideToClose: false,
                templateUrl: "app/plugins/servicesWizard/modals/launch.services.html",
                controller: "meevo.plugins.servicesWizard.LaunchServicesController",
                controllerAs: "wizard",
                bindToController: true,
                locals: { showInfo: false, isImported: false, hasNoServices: false}
            }

            scope.getServicesWizardSecurityKey = (): any => {
                return this.securityKeys.DATA_SERVICESWIZARD + this.securityParts.KEY_PART_READ;
            }

            if (scope.baseEndpoint === 'service' && scope.isSingleLocation()) {
                this.securityService.checkSecurityKey(scope.getServicesWizardSecurityKey())
                    .then((permission) => {
                        if (permission == Meevo.Model.SecurityAccessEnum.Grant) {
                            this.dataService.getTotalCount('service').then((res) => {
                                if (res == 0) {
                                    scope.hasNoServices = true;
                                    scope.showLaunchService = true;
                                    scope.gotoServicesWizard();
                                }
                            })
                        }
                    })
            }

            scope.gotoServicesWizard = (): void => {
                servicesWizardModal.locals['showInfo'] = false;
                servicesWizardModal.locals['hasNoServices'] = scope.hasNoServices;
                this.modalService.showCustom(servicesWizardModal).then((res) => {});
            }

            scope.showServicesWizardInfo = (): void => {
                servicesWizardModal.locals['showInfo'] = true
                this.modalService.showCustom(servicesWizardModal).then((res) => { })
            }

            scope.supportsInactive = angular.isDefined(scope.supportsInactive) ? scope.supportsInactive : true;

            scope.rootCriteria = {};

            if (angular.isUndefined(scope.topMargin)) {
                scope.topMargin = "";
            }

            if (angular.isUndefined(scope.showResults)) {
                scope.showResults = true;
            }

            if (angular.isUndefined(scope.showBottomCrudBar)) {
                scope.showBottomCrudBar = false;
            }

            if (angular.isUndefined(scope.showTableHeaderRegardlessOfCommonRules)) {
                scope.showTableHeaderRegardlessOfCommonRules = false;
            }

            scope.getAddSecurityKey = (): string => {
                return scope.baseMainKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
            }

            var securityCheck = <Meevo.Components.Common.SecurityService>this.securityService;
            // TODO: Improve this implementation
            securityCheck.checkSecurityKey(scope.getAddSecurityKey())
                .then(response => {
                    scope._showAdd = response === Model.SecurityAccessEnum.Grant;
                });

            scope._showAdd = false;
            scope.showAdd = (): boolean => {
                return scope.isApplicationModeCO()
                    ? (Model.Guard.isNothing(scope.criteria.coSearchType) || scope.criteria.coSearchType === CoSearchType.CentralOffice) && scope._showAdd
                    : scope._showAdd;
            }



            scope.userHasSingleBusinessType = this.identityService.userBusinessTypes.length == 1 ? this.identityService.userBusinessTypes[0] : null;

            scope.tenantBusinessTypeCount = this.identityService.tenantBusinessTypeCount;

            scope.userHasAnyBusinesstypeAccess = this.identityService.userBusinessTypes.length > 0;

                scope.isUserHasBusinessTypeIds = (): boolean => {
                return scope.isApplicationModeCO()
                    && this.identityService.isUserHasBusinessTypeIds();
            }
            if (scope.isApplicationModeCO() || scope.showTableHeaderRegardlessOfCommonRules) {
                scope.criteria.coSearchType = CoSearchType.CentralOffice;
                // Build DisplayName sortable columns
                scope.displayNameColumn = scope.displayNameColumnsCustom
                    ? scope.displayNameColumnsCustom
                    : { header: "Display Name", fieldName: 'DisplayName', sortDirection: Model.SortDirection.Ascending, width: 20 };
                // Build CO sortable columns
                scope.coColumns = scope.coColumnsCustom
                    ? scope.coColumnsCustom
                    : [
                        { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 35 },
                        { header: "Located At", fieldName: 'AtLocationName', sortDirection: null, width: 35 },
                        { header: "Status", fieldName: 'ObjectState', sortDirection: null, width: 15 }
                        //{ header: "Exists At", fieldName: 'TotalLocations, AvailableAtLocations', sortDirection: null, width: 15 }
                    ];

            }
            scope.loggedInUserId = { UserID: this.identityService.loggedInUserId() };

            scope.columnSort = (header: string): void => {
                if (Model.Guard.isSomething(scope.disableSorting) && scope.disableSorting) {
                    return;
                }

                if (Model.Guard.isSomething(header)) {
                    // Prepare target sorting column
                    if (scope.displayNameColumn.header === header) {
                        scope.toggleSortColumn(scope.displayNameColumn);
                        scope.selectedSortColumn = scope.displayNameColumn;
                    }
                    else {
                        var column = _.find(scope.coColumns, (c: any) => c.header === header);
                        scope.toggleSortColumn(column);
                        scope.selectedSortColumn = column;
                    }
                }
                // Invoke search wih sorted column
                if (Model.Guard.isSomething(scope.selectedSortColumn)) {
                    scope.search();
                }
            }

            // Can be used to clear columns
            scope.resetColumns = (): void => {
                scope.displayNameColumn.sortDirection = null;
                _.forEach(scope.coColumns, (c: any) => c.sortDirection = null);
            }

            scope.toggleSortColumn = (column: any): void => {
                if (Model.Guard.isSomething(column)) {
                    if (column.sortDirection === Model.SortDirection.Ascending)
                        column.sortDirection = Model.SortDirection.Descending
                    else
                        column.sortDirection = Model.SortDirection.Ascending
                }
            }

            scope.selectedSortColumn = null;

            if (Model.Guard.isSomething(scope.searchContextCriteria)) {
                // Applies custom criteria
                scope.criteria = angular.copy(scope.searchContextCriteria);
                // Ensures criteria is truthy
                scope.criteria.includeActive = true;
                scope.criteria.view = scope.view;
            }

            scope.intelligentSearch = {};
            scope.showAdvanced = false;

            let translate = this.$translate;

            //angular.element('#maint_form_search_container .virtualRepeatdemoInfiniteScroll #vertical-container').css('height', (angular.element('.main-content-container').height() - 185).toString());
            //angular.element(window).on('resize', function () {
            //  scope.$apply(function () {
            //    angular.element('#maint_form_search_container .virtualRepeatdemoInfiniteScroll #vertical-container').css('height', (angular.element('.main-content-container').height() - 185).toString());
            //  })
            //});

            scope.add = (preventUsageTracking: boolean = false): void => {
                scope.selectedItemId = null;
                // Handle add hook implementation
                if (_.isFunction(scope.notificationBeforeAddState)) {
                    scope.processNotificationBeforeAddState();
                } else {
                    scope.visualState = Model.MaintenanceFormVisualState.Detail;
                }
                if (preventUsageTracking) return;
                scope.trackUsage(Model.VerbEnum.AddNewButtonClicked, scope.criteria);
            }

            scope.limitExceededAdd = ($event): void => {
                scope.selectedItemId = null;
                if (scope.canLocationAdd < 1) {
                    this.modalService.error("MESSAGE_LIMIT_EXCEEDE_USER");
                    scope.$setDirty();
                    $event.stopPropagation();
                }

            }

            scope.processNotificationBeforeAddState = (): void => {
                scope.suppressSearch = true;
                scope.notificationBeforeAddState()
                    .then(result => {
                        scope.visualState = Model.MaintenanceFormVisualState.Detail;
                    })
                    .finally(() => { scope.suppressSearch = false; });
            }

            scope.detail = (id: Guid, atLocationId: number): void => {
                scope.asLocationId = atLocationId;
                scope.selectedItemId = id;
                scope.hideCoFilters = false;
                if (scope.items && scope.items.loadedPages) {
                    scope.searchContext = scope.items.loadedPages[0];
                } else {
                    scope.searchContext = [];
                }
                // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
                if (scope.initialEditSection)
                    scope.initialEditSection = undefined;
                scope.visualState = Model.MaintenanceFormVisualState.Detail;
            }

            /* START: Infinite Scroll Data Retrieval */

            scope.toggleShowAdvanced = (): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    preserveScope: true,
                    scope: scope,
                    templateUrl: scope.advancedSearchTemplate,
                    controller: scope.templateController,
                    controllerAs: "vm",
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {}
                }

                this.modalService.showCustom(options);
            }
            scope.toggleShowAdvancedMobile = () => {
                scope.showAdvancedMobile = !scope.showAdvancedMobile;
            }


            scope.toggleCoMenu = (): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    preserveScope: true,
                    scope: scope,
                    templateUrl: scope.coSearchTemplate,
                    controller: scope.templateController,
                    controllerAs: "vm",
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {}
                }
                this.modalService.showCustom(options);

            }

            scope.businessTypeCriteria = { IncludeAllLocationsListItem: Model.Guard.isNothing(scope.allowAllBusinesstype) ? true : scope.allowAllBusinesstype };

            scope.setupPagedResultItems = (): void => {
                if (scope.postItemRetrievalFunction) {
                    scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint, scope.postItemRetrievalFunction, scope.searchContext);
                } else {
                    scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint);
                }
            }

            scope.setupPagedResultItems();

            scope.search = (): void => {

                if (scope.suppressSearch)
                    return;
                scope.hideCoFilters = true;
                scope.showCo = false;
                if (scope.maintenanceSearchForm.$valid) {
                    if (angular.isFunction(scope.preSearchCallback)) {
                        scope.preSearchCallback({
                            criteria: scope.criteria,
                            rootCriteria: scope.rootCriteria
                        });
                    }

                    if (!(scope.criteria.location == null || scope.criteria.location.id === undefined || scope.criteria.location.id == null || scope.criteria.location.id.length <= 0)) {
                        scope.criteria.coFilterByLocationId = scope.criteria.location.id;
                    }
                    else {
                        scope.criteria.coFilterByLocationId = null;
                    }

                    if (!(scope.criteria.businessType == null || scope.criteria.businessType.id === undefined || scope.criteria.businessType.id == null || scope.criteria.businessType.id.length <= 0)) {
                        if (scope.criteria.coSearchType == 0)
                            scope.criteria.coBusinessTypeId = scope.criteria.businessType.id;
                        else
                            scope.criteria.coBusinessTypeId = null;
                    }
                    else {
                        scope.criteria.coBusinessTypeId = null;
                    }

                    if (scope.areStatesUntruthy() && scope.isCloseWhenStatesUntruthySpecified() && !scope.criteria.showTerminated && !scope.criteria.showExpired) {
                        scope.clearAdvancedSearchAndApply();
                        scope.items.clearSearch();
                    } else {
                        // Determine whether sorting by column
                        var applyColumnSorting = Model.Guard.isSomething(scope.selectedSortColumn);
                        let request = {
                            pageNumber: 0,
                            itemsPerPage: this.itemsPerPage,
                            criteria: scope.criteria,
                            sortBy: applyColumnSorting ? scope.selectedSortColumn.fieldName : null,  // default should be null so it can be used as the stored procs default
                            sortDirection: applyColumnSorting ? scope.selectedSortColumn.sortDirection : Model.SortDirection.Ascending,
                            asLocationId: scope.locationId
                        }
                        // Always pass criteria and add value into filter
                        // TODO: Refactor out intelligentSearch and just use filter
                        var filterValue = Model.Guard.isSomething(`%${scope.intelligentSearch.filter}%`) ? scope.intelligentSearch.filter : null;
                        scope.criteria.filter = filterValue;
                        // Close advanced search
                        scope.closeModal();
                        var savedRequest = angular.copy(request);
                        scope.items.initSearch(savedRequest, scope.searchFallbackCriteria, scope.rootCriteria).then((res) => {

                        })
                        //TODO: Need to add implementation that clears out filter when advanced filter fields are set
                        // usage tracking
                        scope.trackUsage(Model.VerbEnum.SearchButtonClicked, scope.criteria);
                    }
                } else {
                    this.modalService.error("MESSAGE_INVALID_SEARCH", 0, true);
                }
            }

            scope.getTotalActiveCount = (baseEndpoint?: string): any => {
                let baseEndPoint = scope.baseEndpoint === 'productvariant' ? 'product' : scope.baseEndpoint
                this.dataService.getTotalCount(baseEndPoint).then((res) => {
                    scope.totalActiveCount = res;
                })
            }

            scope.isCloseWhenStatesUntruthySpecified = (): boolean => {
                return (scope.closeWhenStatesUntruthy != undefined) ? scope.closeWhenStatesUntruthy : true;
            }

            scope.areStatesUntruthy = (): boolean => {
                return !scope.criteria.includeActive && !scope.criteria.includeInactive && !scope.criteria.includeDeleted;
            }

            scope.clearFilter = (): void => {
                scope.intelligentSearch.filter = null;
                scope.criteria.filter = null;
            }

            scope.clearAdvancedSearch = (): void => {
                scope.clearFilter();
                if (Model.Guard.isSomething(scope.clearSearchContextCriteria)) {
                    scope.clearSearchContextCriteria();
                }
                scope.initializeCriteria();

                scope.search();
            }

            scope.clearSearchCriteriaAndResults = (): void => {
                scope.clearFilter();
                if (Model.Guard.isSomething(scope.clearSearchContextCriteria)) {
                    scope.clearSearchContextCriteria();
                }
                scope.initializeCriteria();
                scope.setupPagedResultItems();
            }

            scope.clearAdvancedSearchAndApply = (): void => {
                scope.clearFilter();
                scope.initializeCriteria();
                scope.closeModal();
            }

            scope.initializeCriteria = (): void => {
                scope.criteria = {
                    includeActive: true,
                    view: scope.view
                };

                scope.rootCriteria = {};
                if (scope.isApplicationModeCO()) {
                    scope.criteria.coSearchType = this.identityService.userBusinessTypes.length > 0 ? CoSearchType.CentralOffice : CoSearchType.Location;
                    scope.criteria.coSearchResultFilter = CoSearchResultsFilter.All;
                    scope.criteria.maintenanceMode = true;
                    if (this.identityService.userBusinessTypes.length == 1) {
                        scope.criteria.businessType = this.identityService.userBusinessTypes[0];
                        scope.criteria.coBusinessTypeId = this.identityService.userBusinessTypes[0].id;
                    }
                }

                if (Model.Guard.isSomething(scope.searchContextCriteria)) {
                    // Applies custom criteria
                    scope.criteria = angular.copy(scope.searchContextCriteria);
                    // Ensures criteria is truthy
                    scope.criteria.includeActive = true;
                    scope.criteria.view = scope.view;
                }
            }

            /* END: Infinite Scroll Data Retrieval */

            scope.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }

            scope.closeModal = (): void => {
                this.$mdDialog.cancel();
            }

            //scope.toggleCoMenu = (): void => {
            //    scope.showCo = !scope.showCo;
            //}

            scope.toggleFilter = (key, $event): void => {
                scope.criteria[key] = !scope.criteria[key];
                $event.stopPropagation();
                scope.search();
            }
            scope.toggleLocationSearchFilter = ($event): void => {
                scope.criteria.coSearchResultFilter = 0;
                $event.stopPropagation();
                scope.search();
            }

            scope.toggleSearchFilter = ($event): void => {
                scope.intelligentSearch.filter = '';
                $event.stopPropagation();
                scope.search();
            }

            // NOTE: This clears the advanced filter when text is used for filtering
            //if (!scope.preserveAdvanceFilter) {
            //  scope.$watch(() => scope.intelligentSearch.filter, (newVal: boolean, oldVal: boolean) => {
            //    if (Meevo.Model.Guard.isNothing(oldVal) && Meevo.Model.Guard.isSomething(newVal))
            //      scope.initializeCriteria();
            //  });
            //}

            scope.toggleDateFilter = ($event): void => {
                scope.criteria.startDate = null;
                scope.criteria.endDate = null;
                $event.stopPropagation();
                scope.search();
            }

            scope.assignFilterCriteria = (key, value): void => {
                scope.criteria[key] = value;
            }

            scope.trackUsage = (verb, payload): void => {
                let nounValue = Model.NounEnum[scope.noun];
                if (nounValue) {
                    let trackInfo: Model.TrackingItem = new Model.TrackingItem(Model.NounEnum[nounValue], verb, payload);
                    this.trackingService.saveTrackingInfo(trackInfo);
                }
            }

            scope.$watch(() => scope.coFilterBoolean, (newVal: boolean, oldVal: boolean) => {
                if (!angular.isUndefined(scope.coFilterBoolean))
                    scope.hideCoFilters = scope.coFilterBoolean;
            });

            if (scope.coColumnsCustom) {
                scope.$watch(() => scope.coColumnsCustom, (newVal: boolean, oldVal: boolean) => {
                    if (newVal === oldVal || angular.isUndefined(newVal)) return;

                    scope.coColumns = newVal;
                });
            }

            if (scope.displayNameColumnsCustom) {
                scope.$watch(() => scope.displayNameColumnsCustom, (newVal: boolean, oldVal: boolean) => {
                    if (newVal === oldVal || angular.isUndefined(newVal)) return;

                    scope.displayNameColumn = newVal;
                });
            }

            const searchShortCutGroup = new ShortCutGroup([
                { shortCutName: 'DATA_MAINTENANCE_ADD', callback: () => scope.add(true), securityKey: scope.getAddSecurityKey() }
            ], { noun: scope.noun });

            scope.$watch('visualState', (newValue) => {
                if (newValue === Model.MaintenanceFormVisualState.Search) {
                    this.shortCutsService.activateGroup(searchShortCutGroup);
                }
            });

            const stateName = this.$state.current.name;
            scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
                if (toState.name === stateName && scope.visualState === Model.MaintenanceFormVisualState.Search) {
                    this.shortCutsService.activateGroup(searchShortCutGroup);
                } else if (fromState.name === stateName) {
                    this.shortCutsService.deactivateGroup(searchShortCutGroup);
                }
            });

            if (scope.visualState) {
                this.shortCutsService.activateGroup(searchShortCutGroup);
            }

            scope.$watch(() => scope.baseEndpoint, (newVal: string, oldVal: string) => {
                if (newVal === oldVal || angular.isUndefined(newVal)) return;

                scope.setupPagedResultItems();
            });

        }

        constructor(
            private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private loggingService: Meevo.Components.Logging.ILoggingService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $mdDialog: ng.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private $q: angular.IQService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: angular.IRootScopeService,
                $state: angular.ui.IStateService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                trackingService: Meevo.Components.Tracking.ITrackingService,
                loggingService: Meevo.Components.Logging.ILoggingService,
                modalService: Meevo.Components.Modal.IModalService,
                $mdDialog: ng.material.IDialogService,
                $translate: angular.translate.ITranslateService,
                identityService: Meevo.Components.Common.IIdentityService,
                securityService: Meevo.Components.Common.ISecurityService,
                $q: angular.IQService,
                shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) => {
                return new MaintenanceFormSearch($rootScope, $state, dataService, trackingService,
                    loggingService, modalService, $mdDialog, $translate, identityService, securityService, $q, shortCutsService);
            }

            directive.$inject = ["$rootScope", "$state", "meevo.components.common.DataService",
                "meevo.components.tracking.TrackingService",
                "meevo.components.logging.LoggingService",
                "meevo.components.modal.ModalService", "$mdDialog", "$translate", "meevo.components.common.IdentityService",
                "meevo.components.common.SecurityService",
                "$q", "meevo.components.short-cuts.ShortCutsService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMaintenanceFormSearch", MaintenanceFormSearch.factory());
}
